import { useQuery } from '@tanstack/react-query'
import api from '@utils/api'
import type { AxiosResponse } from 'axios'
import { useState } from 'react'

function usePriceHistoryDrawer(asOfDate: string | Date) {
  const [visible, setVisible] = useState(false)
  const [priceManagementRow, setPriceManagementRow] = useState<Gravitate.SupplyManagementOption>()

  const { isPending, data } = useQuery({
    queryKey: ['priceHistoryQuery', asOfDate, priceManagementRow?.curve_id],
    queryFn: () => {
      if (priceManagementRow?.curve_id) {
        return api.priceHistory(asOfDate, priceManagementRow?.curve_id || '') as Promise<
          AxiosResponse<Gravitate.SupplyManagementOption[]>
        >
      }
      return null
    },
  })

  const showDrawer = (priceHistory: Gravitate.SupplyManagementOption) => {
    setPriceManagementRow(priceHistory)
    setVisible(true)
  }

  const closeDrawer = () => {
    setVisible(false)
  }

  return {
    visible,
    priceManagementRow,
    historyRows: data?.data || [],
    isLoading: isPending,
    showDrawer,
    closeDrawer,
  }
}

export default usePriceHistoryDrawer as (asOfDate: string | Date) => ReturnType<typeof usePriceHistoryDrawer>
